import * as React from "react"
export const ToolbarDimensions = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
        height={20}
         viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <g >
      <path
        fill="#6C757D"
        d="M16.667 11.667H8.333V3.333A3.337 3.337 0 0 0 5 0H3.333A3.337 3.337 0 0 0 0 3.333v12.5A4.171 4.171 0 0 0 4.167 20h12.5A3.337 3.337 0 0 0 20 16.667V15a3.337 3.337 0 0 0-3.333-3.333Zm1.666 5c0 .919-.747 1.666-1.666 1.666h-12.5a2.503 2.503 0 0 1-2.5-2.5v-12.5c0-.919.747-1.666 1.666-1.666H5c.92 0 1.667.747 1.667 1.666V5H5a.833.833 0 1 0 0 1.667h1.667v1.666H5A.833.833 0 1 0 5 10h1.667v1.667H5a.833.833 0 1 0 0 1.666h1.667V15a.833.833 0 1 0 1.666 0v-1.667H10V15a.833.833 0 1 0 1.667 0v-1.667h1.666V15A.833.833 0 1 0 15 15v-1.667h1.667c.919 0 1.666.748 1.666 1.667v1.667Z"
      />
    </g>

  </svg>
)
